import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssistantPickerScreenComponent} from './components/assistant-picker-screen/assistant-picker-screen.component';
import {AssistantProfileComponent} from './components/assistant-profile/assistant-profile.component';
import {AssistantWindowComponent} from './components/assistant-window/assistant-window.component';
import {TagModule} from 'primeng/tag';
import {AssistantConversationComponent} from './components/assistant-conversation/assistant-conversation.component';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {PaginatorModule} from 'primeng/paginator';
import {MessageModule} from 'primeng/message';
import {SpinnerModule} from 'primeng/spinner';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {AppCommonModule} from '../app-common/app-common.module';
import {DialogModule} from 'primeng/dialog';
import {TooltipModule} from 'primeng/tooltip';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {
  AssistantProfilePictureComponent
} from './components/assistant-profile-picture/assistant-profile-picture.component';
import { AiSummarizationPopupComponent } from './components/ai-summarization-popup/ai-summarization-popup.component';
import { AiToolsComponent } from './components/ai-tools-overlay/ai-tools.component';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import { AiMessageComponent } from './components/ai-message/ai-message.component';
import { AiMessageListComponent } from './components/ai-message-list/ai-message-list.component';
import {AiGenerationPopupComponent} from "./components/ai-generation-popup/ai-generation-popup.component";


@NgModule({
  declarations: [
    AssistantWindowComponent,
    AssistantPickerScreenComponent,
    AssistantProfileComponent,
    AssistantConversationComponent,
    AssistantProfilePictureComponent,
    AiSummarizationPopupComponent,
    AiGenerationPopupComponent,
    AiToolsComponent,
    AiMessageComponent,
    AiMessageListComponent,
  ],
  exports: [
    AssistantWindowComponent,
    AssistantProfileComponent,
    AssistantProfilePictureComponent,
    AiToolsComponent,
  ],
  imports: [
    AppCommonModule,
    CommonModule,
    TagModule,
    InputTextModule,
    ButtonModule,
    PaginatorModule,
    MessageModule,
    SpinnerModule,
    ProgressSpinnerModule,
    WidgetLibraryModule,
    DialogModule,
    TooltipModule,
    ConfirmDialogModule,
    OverlayPanelModule
  ],
  providers: []
})
export class AiAssistantModule {
}
